module.exports = __webpack_public_path__ + "media/techforum.23066244.mp4";